import { Box,  useMediaQuery, useTheme } from '@mui/material'
import React, { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import { FormsActions, FormsSelector } from '../../store/forms'

import {  SidebarDrawer, SidebarMobilePopover } from './subComponent'

export const Sidebar = () => {

  const dispatch = useDispatch()
  const theme = useTheme()
  const [selectedIndex, setSelectedIndex] = useState(0)
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const formId = 'navigationSidebar'
  const formValues = useSelector((state: RootState) => FormsSelector.getFormValues(state, formId))
  const { open = false } = formValues
  const ele = useRef<HTMLDivElement | null>(null)

  const handleDrawerClose = () => {
    dispatch(FormsActions.setValue({ id: 'navigationSidebar', open: false }))
  }

  const handleListItemClick = (index: number) => {
    setSelectedIndex(index)
    if (isMobile) {
      dispatch(FormsActions.setValue({ id: formId, open: false }))
    }
  }

  return (
    <Box sx={{
      flex:'0 1 0%',
      width: '0',
      display: 'flex'}} ref={ele}>
      {isMobile ? (
        <SidebarMobilePopover
          open={open}
          onClose={handleDrawerClose}
          selectedIndex={selectedIndex}
          onListItemClick={handleListItemClick}
        />
      ) : (
        <SidebarDrawer
          open={open}
          containerRef={ele}
          onClose={handleDrawerClose}
          selectedIndex={selectedIndex}
          onListItemClick={handleListItemClick}
        />
      )}
    </Box>
  )
}
